.legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-primary);
  font-size: 10px;
  line-height: 16px;
  cursor: pointer;
}

.item[aria-pressed='false'] {
  color: var(--text-tertiary);
}

.item:focus-visible {
  outline: 2px solid var(--light-blue);
  outline-offset: 2px;
}

.swatch {
  width: 8px;
  height: 8px;
  background-color: var(--gray-400);
}
